export default "__VITE_ASSET__aee442e6__"